module.exports = __webpack_public_path__ + "static/media/Lato-Thin.9a77fbaa.ttf";